import React, { useState } from 'react';

import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

import { AuthState } from '@aws-amplify/ui-components';
import AuthForm from './AuthForm';

const SignInModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  defaultAuthState: AuthState.SignIn | AuthState.SignUp;
}> = (props) => {
  const [hasFinishedLogin, setHasFinishedLogin] = useState(false);
  const { isOpen, onClose, defaultAuthState } = props;

  return (
    <Modal isOpen={!hasFinishedLogin && isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody borderRadius="5px">
          <ModalCloseButton zIndex={2} />
          <Box height="2rem" />
          <AuthForm
            initialState={defaultAuthState}
            afterComplete={() => setHasFinishedLogin(true)}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SignInModal;
